import { isRepaymentSettled, repaymentStatusLabel } from "../../utils/repaymentStatus";
import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import {
  Button,
  Col,
  Form,
  InputNumber,
  message,
  Modal,
  Row,
  Select,
  Tabs,
  Tooltip,
} from "antd";
import { QuestionOutlined } from "@ant-design/icons";
import Cookies from "js-cookie";
import ModalApplication from "./modal-application";
import singlogo from "../../pages/smart-lend-frontend/src/img/singpass_logo.png";
import TableOfferedLoan from "../../components/TableOfferedLoan";
import LoanDetails from "./loan-details";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { format } from "date-fns";
import { useHistory, useLocation } from "react-router-dom";
import * as Icons from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./LoanHubCorporate.css";
import {
  createTrackingId,
  getDeviceType,
  trackUserProductInterest,
} from "../../utils/userProductInterest";
import {
  dismissOfferAlert,
  shouldShowOfferAlert,
} from "../../utils/offerAlert";
import OfferReadyModal from "../../components/OfferReadyModal";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import FaqSection from "./Loan-hub-faq";

const { Option } = Select;
const { TabPane } = Tabs;

const formatCurrency = (value) => {
  const numberValue = Number(value);
  if (!Number.isFinite(numberValue)) {
    return "$0.00";
  }

  return numberValue.toLocaleString("en-US", {
    style: "currency",
    currency: "SGD",
  });
};

const LoanHub = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [loanType, setLoanType] = useState("simple");
  const [loanCategory] = useState("business");
  const [adminFee, setAdminFeeSelected] = useState("0.05");
  const [requestingLoanAmount, setRequestLoanAmount] = useState(50000);
  const [expectingInterestRate, setExpectingInterestRate] = useState("3");
  const [loanPeriod, setLoanPeriod] = useState(12);
  const [requestPrincipal, setLoanPrincipal] = useState(0);
  const [monthlyInstallment, setExpectedMonthlyInstallment] = useState(0);
  const [totalInterestPayable, setTotalInterestPayable] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [syncWithSingpass, setSyncWithSingpass] = useState(0);
  const [reminder, setReminder] = useState(false);
  const [existingLoanData, setExistingLoanData] = useState(false);
  const [promoCode, setPromoCode] = useState(null);
  const [keymanChoices, setKeymanChoices] = useState([]);
  const [totalAdminFee, setTotalAdminFee] = useState(0);
  const [totalAdminFeeByMonth, setTotalAdminFeeByMonth] = useState(0);
  const [showEstimateBreakdown, setShowEstimateBreakdown] = useState(false);
  const [requestedLoans, setRequestedLoans] = useState([]);
  const [requestedLoanModalStates, setRequestedLoanModalStates] = useState({});
  const [offeredLoanDetail, setOfferedLoanDetail] = useState([]);
  const [addDocument, setAddDocument] = useState(null);
  const [authorizationModalOpen, setAuthorizationModalOpen] = useState(false);
  const [authorizationList, setAuthorizationList] = useState([]);
  const [conciergeModalOpen, setConciergeModalOpen] = useState(false);
  const [conciergeAmount, setConciergeAmount] = useState(null);
  const [conciergeId, setConciergeId] = useState(null);
  const [lenderProfileData, setLenderProfileData] = useState(null);
  const [acceptedLoans, setAcceptedLoans] = useState([]);
  const [acceptedLenderProfileData, setAcceptedLenderProfileData] =
    useState(null);
  const [repaymentModalLoan, setRepaymentModalLoan] = useState(null);
  const [footerVisible, setFooterVisible] = useState(false);
  const [selectedOfferId, setSelectedOfferId] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [statusMessage, setStatusMessage] = useState({
    message: "",
    color: "",
  });
  const [rejectModal, setRejectModal] = useState(false);
  const [rejectingOffer, setRejectingOffer] = useState(null);
  const [rejectingReason, setRejectingReason] = useState(0);
  const [hideLoanModal, setHideLoanModal] = useState(false);
  const [acceptingOfferLoanId, setAcceptingLoanOfferLoanId] = useState(null);
  const [lenderId, setLenderId] = useState(null);
  const [type, setType] = useState(null);
  const [principal, setPrincipal] = useState(null);
  const [amount, setAmount] = useState(null);
  const [adminFeeValue, setAdminFeeValue] = useState(null);
  const [interestRateValue, setInterestRateValue] = useState(null);
  const [periodValue, setPeriodValue] = useState(null);
  const [monthlyInstallmentValue, setMonthlyInstallmentValue] = useState(null);
  const [revenueValue, setRevenueValue] = useState(null);
  const [repaymentTenor, setRepaymentTenor] = useState("");
  const [express, setExpress] = useState(null);
  const [processingFeeValue, setProcessingFeeValue] = useState(null);
  const [totalAdminFeeValue, setTotalAdminFeeValue] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [statementCoverageMap, setStatementCoverageMap] = useState({});
  const [statementCoverageLoading, setStatementCoverageLoading] = useState({});
  const [statementCoverageModal, setStatementCoverageModal] = useState({
    open: false,
    loan: null,
    missingMonths: [],
  });
  const [statementCoverageUploads, setStatementCoverageUploads] = useState({});
  const [statementCoverageSubmitting, setStatementCoverageSubmitting] =
    useState(false);
  const [activeTab, setActiveTab] = useState("apply");
  const [offerAlert, setOfferAlert] = useState({ open: false, data: null });
  const [displayAds, setDisplayAds] = useState([]);
  const [adImage, setAdImage] = useState(null);
  const [adLink, setAdLink] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const history = useHistory();
  const location = useLocation();
  const showLowInterestRateWarning = Number(expectingInterestRate) === 2;
  const showHighAmountWarning = Number(requestingLoanAmount) > 500000;
  const showLongTenorWarning = Number(loanPeriod) > 12;
  const trackingRef = useRef({
    trackingId: createTrackingId(),
    enteredLoanAmount: false,
    enteredInterestRate: false,
    enteredTenor: false,
    loanAmount: null,
  });

  const sendTrackingUpdate = (updates = {}) => {
    trackingRef.current = { ...trackingRef.current, ...updates };
    trackUserProductInterest({
      trackingId: trackingRef.current.trackingId,
      productPage: "b-loan-hub",
      deviceType: getDeviceType(isMobile),
      enteredLoanAmount: trackingRef.current.enteredLoanAmount,
      enteredInterestRate: trackingRef.current.enteredInterestRate,
      enteredTenor: trackingRef.current.enteredTenor,
      loanAmount: trackingRef.current.loanAmount,
    });
  };
  const switchTab = (key) => {
    setActiveTab(key);
    const params = new URLSearchParams(location.search);
    params.set("tab", key);
    history.replace({ search: params.toString() });
  };
  const iconLibrary = Icons;
  const statementCoverageEnabled =
    userDetails?.active_email === "iaaijojojo97@gmail.com" ||
    userDetails?.email === "iaaijojojo97@gmail.com" ||
    userDetails?.active_email === "towkay@smart-towkay.com" ||
    userDetails?.email === "towkay@smart-towkay.com";

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    sendTrackingUpdate();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get("tab");
    if (tabParam) {
      setActiveTab(tabParam);
    }
  }, [location.search]);

  useEffect(() => {
    if (!statementCoverageEnabled || !requestedLoans.length) return;
    requestedLoans.forEach((loan) => {
      if (!statementCoverageMap[loan.loan_id]) {
        fetchStatementCoverage(loan.loan_id);
      }
    });
  }, [statementCoverageEnabled, requestedLoans]);

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/ads/getAdsByScreen?screen=bApplyLoan",
          options,
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        setDisplayAds(data["ads"]);
        setAdImage(data.ads[0].image);
        setAdLink(data.ads[0].link);
      } catch (error) {
        console.error(error);
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    if (displayAds.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % displayAds.length);
      }, 3200);

      return () => clearInterval(interval);
    }
  }, [displayAds]);

  useEffect(() => {
    if (displayAds.length > 0) {
      setAdImage(displayAds[currentIndex].image);
      setAdLink(displayAds[currentIndex].link);
    }
  }, [currentIndex, displayAds]);

  const fetchSingpassData = async () => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/singpass/getSingpassData",
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + Cookies.get("token"),
            Accept: "application/json",
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
      }

      const json = await response.json();

      const lastUpdateDate = new Date(json.last_updated_at);
      const currentDate = new Date();
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(currentDate.getMonth() - 1);

      if (lastUpdateDate < oneMonthAgo) {
        setReminder(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchExistingLoanData = async () => {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + Cookies.get("token"));

    const options = {
      method: "GET",
      headers: headers,
    };

    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/loan/pendingLoan/viewPendingLoan",
        options,
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const data = await response.json();
      let pendingLoanToPush = false;

      for (const loan of data["Pending Loans"]) {
        if (
          loan.status === "pending" ||
          loan.status === "offered" ||
          loan.status === "accepted"
        ) {
          const lastUpdateDate = new Date(loan.created_at);
          const currentDate = new Date();
          const oneMonthAgo = new Date();
          oneMonthAgo.setMonth(currentDate.getMonth() - 1);

          if (lastUpdateDate > oneMonthAgo) {
            pendingLoanToPush = true;
          }
        }
      }

      setExistingLoanData(pendingLoanToPush);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchOfferAlert = async () => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/loan/offer-alert?product=corporate",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (!response.ok) throw new Error("Unable to check offer alert");
      const json = await response.json();
      if (activeTab !== "requested" && shouldShowOfferAlert(json)) {
        setOfferAlert({ open: true, data: json });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const closeOfferAlert = () => {
    dismissOfferAlert(offerAlert.data);
    setOfferAlert({ open: false, data: null });
  };

  const viewOfferFromAlert = () => {
    dismissOfferAlert(offerAlert.data);
    setOfferAlert({ open: false, data: null });
    switchTab("requested");
  };

  const checkSingpassDetails = async () => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/user/checkSingpassSync",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const data = await response.json();
      setSyncWithSingpass(data.singpass_sync);
    } catch (error) {
      console.error(error);
    }
  };

  const getKeymanChoices = async () => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/loan/getCompanyShareholders",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        },
      );
      const json = await response.json();
      if (response.status === 200) {
        const uniqueDirectors = [...new Set(json.other_directors)];
        setKeymanChoices(uniqueDirectors);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getPromoCode = async () => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/apply_promo_code",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        },
      );
      const json = await response.json();
      if (response.status === 200) {
        setPromoCode(json.promo_code);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchExistingLoanData();
    fetchOfferAlert();
    fetchSingpassData();
    checkSingpassDetails();
    getPromoCode();
    getKeymanChoices();
    fetchRequestedLoans();
    fetchAcceptedLoans();
    getUserDetails();
  }, []);

  useEffect(() => {
    if (
      requestingLoanAmount === "" ||
      expectingInterestRate === "" ||
      loanPeriod === ""
    ) {
      setLoanPrincipal(0);
      setExpectedMonthlyInstallment(0);
      setTotalInterestPayable(0);
      return;
    }

    const amount = Number(requestingLoanAmount);
    const rate = Number(expectingInterestRate) / 100;
    const period = Number(loanPeriod);
    const monthlyInstallmentValue = amount / period + amount * rate;
    const principalValue = monthlyInstallmentValue * period || 0;
    const totalAdminFeeValue = (amount + amount * rate) * 0;
    const totalAdminFeeByMonthValue = totalAdminFeeValue;
    const totalInterestValue =
      principalValue - amount - totalAdminFeeValue || 0;

    setLoanPrincipal(Number(principalValue.toFixed(2)));
    setExpectedMonthlyInstallment(Number(monthlyInstallmentValue.toFixed(2)));
    setTotalInterestPayable(Number(totalInterestValue.toFixed(2)));
    setTotalAdminFee(Number(totalAdminFeeValue.toFixed(2)));
    setTotalAdminFeeByMonth(Number(totalAdminFeeByMonthValue.toFixed(2)));
  }, [requestingLoanAmount, expectingInterestRate, loanPeriod]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const isApplyDisabled =
    !syncWithSingpass || reminder || existingLoanData || !requestingLoanAmount;

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return format(date, "MMM dd, yyyy");
  };

  const getLoanStatusConfig = (status) => {
    if (status === "pending") {
      return {
        label: "Pending Lender Signdown",
        badgeBg: "#f1f1f1ff",
        badgeColor: "#8d8d8dff",
        borderColor: "#e4e4e4ff",
        cardBg: "#ffffffff",
      };
    }

    return {
      label: "Ongoing Loan",
      badgeBg: "#e8f5f7",
      badgeColor: "#0d5963",
      borderColor: "#6ec1c8",
      cardBg: "#f4fbfc",
    };
  };

  const getRepaymentStatusConfig = (repayment) => ({
    label: repaymentStatusLabel(repayment),
    color: isRepaymentSettled(repayment) ? "#2e7d32" : "#c77700",
  });

  async function fetchRequestedLoans() {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + Cookies.get("token"));

    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/loan/pendingLoan/viewPendingLoan",
        {
          method: "GET",
          headers,
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const data = await response.json();
      setRequestedLoans(data["Pending Loans"]);
    } catch (error) {
      console.error(error);
    }
  }

  const pendingSigndownLoans = acceptedLoans.filter(
    (loan) => loan.status === "pending",
  );
  const ongoingLoans = acceptedLoans.filter(
    (loan) => loan.status !== "pending",
  );

  const renderAcceptedLoanCard = (item) => {
    const statusConfig = getLoanStatusConfig(item.status);
    const isOngoingLoan = item.status === "ongoing";

    const pillClass = item.status === "pending" ? "warning" : "success";

    return (
      <div
        key={item.loan_id}
        className={["slCard", isMobile ? "isMobile" : ""].join(" ")}
        style={{
          /* keep your status-tinted feel but modern */
          borderColor: statusConfig.borderColor,
          background: statusConfig.cardBg,
        }}
      >
        <div className="slTopRow">
          <div className="slPills">
            <span className={`slPill ${pillClass}`}>{statusConfig.label}</span>
            <span className="slPill">Loan ID {item.loan_id}</span>
          </div>
        </div>

        <div className="slRowInline">
          <div
            className="slAvatar"
            onClick={() => handleGetAcceptedLenderProfile(item.lender_id)}
            title="View lender profile"
          >
            {item.lender_details?.profile_design ? (
              JSON.parse(item.lender_details.profile_design).profile
                ?.profile_photo ? (
                <img
                  src={
                    JSON.parse(item.lender_details.profile_design).profile
                      .profile_photo
                  }
                  alt="Lender"
                />
              ) : (
                <div style={{ fontWeight: 900, color: "rgba(15,23,42,0.7)" }}>
                  {getInitials(item.lender_details.principal_name)}
                </div>
              )
            ) : (
              <div style={{ fontWeight: 900, color: "rgba(15,23,42,0.7)" }}>
                {getInitials(item.lender_details?.principal_name)}
              </div>
            )}
          </div>

          <div style={{ minWidth: 0 }}>
            <div className="slTitle">{item.lender_details?.principal_name}</div>
            <div className="slHint">
              Created {formatDate(item.created_at)} •{" "}
              {item.period ? `${item.period} months` : "-"}
            </div>
          </div>
        </div>

        <div className="slMetaGrid">
          <div className="slMetaItem">
            <div className="slMetaK">Loan amount</div>
            <div className="slMetaV">
              {item.amount
                ? item.amount.toLocaleString("en-US", {
                    style: "currency",
                    currency: "SGD",
                  })
                : "-"}
            </div>
          </div>

          <div className="slMetaItem">
            <div className="slMetaK">Monthly</div>
            <div className="slMetaV">
              {item.monthly_installment
                ? item.monthly_installment.toLocaleString("en-US", {
                    style: "currency",
                    currency: "SGD",
                  })
                : "-"}
            </div>
          </div>

          <div className="slMetaItem">
            <div className="slMetaK">Interest</div>
            <div className="slMetaV">
              {item.interest_rate ? `${item.interest_rate}%` : "-"}
            </div>
          </div>

          <div className="slMetaItem">
            <div className="slMetaK">Processing</div>
            <div className="slMetaV">
              {item.processing_fee
                ? `${(item.processing_fee * 100).toFixed(1)}%`
                : "0%"}
            </div>
          </div>

          <div className="slMetaItem" style={{ gridColumn: "1 / -1" }}>
            <div className="slMetaK">Disbursed</div>
            <div className="slMetaV">
              {item.lender_id === "L66489"
                ? parseFloat(
                    item.amount * (1 - item.processing_fee) -
                      item.monthly_installment,
                  ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "SGD",
                  })
                : parseFloat(
                    item.amount * (1 - item.processing_fee),
                  ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "SGD",
                  })}
            </div>
          </div>
        </div>

        {isOngoingLoan ? (
          <div className="slActions">
            <button
              className="slBtn slBtnOutline"
              onClick={() => setRepaymentModalLoan(item)}
            >
              View repayments
            </button>
          </div>
        ) : null}
      </div>
    );
  };

  async function fetchAcceptedLoans() {
    const headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Authorization", "Bearer " + Cookies.get("token"));

    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/agreement/viewListAgreement",
        {
          method: "GET",
          headers,
        },
      );

      if (response.status === 403) {
        throw new Error("Document is not ready yet");
      }

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const data = await response.json();
      setAcceptedLoans(data["Accepted Loan"]);
    } catch (error) {
      console.error("Error fetching accepted loan data:", error);
    }
  }

  const getInitials = (name) => {
    const textToSplit = name?.split(" ") || [];
    const initials =
      textToSplit?.[0]?.[0]?.toUpperCase() +
      (textToSplit?.[1]?.[0]?.toUpperCase() || "");
    return initials || "";
  };

  const getUserDetails = async () => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/profile/getUserDetails",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        },
      );
      if (response.status === 200) {
        const json = await response.json();
        setUserDetails(json.User);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchStatementCoverage = async (loanId) => {
    try {
      setStatementCoverageLoading((prev) => ({ ...prev, [loanId]: true }));
      const response = await fetch(
        `https://www.smart-lend.com/api/bank-document-jobs/coverage?loan_id=${loanId}&loan_type=corporate`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        },
      );
      const json = await response.json();
      if (!response.ok) {
        throw new Error(json?.message || "Unable to load statement coverage.");
      }
      setStatementCoverageMap((prev) => ({ ...prev, [loanId]: json }));
    } catch (error) {
      console.error(error);
    } finally {
      setStatementCoverageLoading((prev) => ({ ...prev, [loanId]: false }));
    }
  };

  const openStatementCoverageModal = (loan, missingMonths) => {
    setStatementCoverageUploads({});
    setStatementCoverageModal({
      open: true,
      loan,
      missingMonths: missingMonths || [],
    });
  };

  const closeStatementCoverageModal = () => {
    setStatementCoverageModal({ open: false, loan: null, missingMonths: [] });
    setStatementCoverageUploads({});
  };

  const handleStatementCoverageUpload = (monthKey, files) => {
    setStatementCoverageUploads((prev) => ({
      ...prev,
      [monthKey]: Array.from(files || []),
    }));
  };

  const uploadCorporateBankFile = async (file, fileId) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", "loan_request");
    formData.append("file_id", fileId);

    const response = await fetch(
      "https://www.smart-lend.com/api/file/uploadUniversalFile",
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
        body: formData,
      },
    );

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data?.message || "File upload failed.");
    }

    const data = await response.json();
    return {
      document_id: data.document_id,
      file_name: data.original_filename,
      file_url: data.url,
    };
  };

  const submitStatementCoverageUploads = async () => {
    if (!statementCoverageModal.loan) return;
    const fileId = `loan_request:${statementCoverageModal.loan.loan_id}`;
    try {
      setStatementCoverageSubmitting(true);
      const uploads = await Promise.all(
        statementCoverageModal.missingMonths.flatMap((month) => {
          const files = statementCoverageUploads[month.key] || [];
          return files.map((file) => uploadCorporateBankFile(file, fileId));
        }),
      );

      if (!uploads.length) {
        message.warning(
          "Please upload bank statements for at least one missing month.",
        );
        return;
      }

      const response = await fetch(
        `https://www.smart-lend.com/api/loan/${statementCoverageModal.loan.loan_id}/bank-statements`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({ documents: uploads }),
        },
      );

      const json = await response.json();
      if (!response.ok) {
        throw new Error(json?.message || "Unable to upload bank statements.");
      }

      message.success("Bank statements added. We'll review them shortly.");
      closeStatementCoverageModal();
      fetchStatementCoverage(statementCoverageModal.loan.loan_id);
    } catch (error) {
      console.error(error);
      message.error(
        error?.message || "Unable to upload missing bank statements.",
      );
    } finally {
      setStatementCoverageSubmitting(false);
    }
  };

  const handleViewOfferedLoan = (loanId) => {
    setRequestedLoanModalStates((prevStates) => ({
      ...prevStates,
      [loanId]: true,
    }));
  };

  const handleCloseRequestedModal = (loanId) => {
    setRequestedLoanModalStates((prevStates) => ({
      ...prevStates,
      [loanId]: false,
    }));
    setOfferedLoanDetail([]);
    setFooterVisible(false);
    setStatusMessage({ message: "", color: "" });
    setLenderProfileData(null);
  };

  const handleGetLenderProfile = async (selectedLenderId) => {
    try {
      const response1 = await fetch(
        "https://www.smart-lend.com/api/user/getLenderProfileDesign",
        {
          method: "POST",
          body: JSON.stringify({ user_id: selectedLenderId }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        },
      );

      const json = await response1.json();
      if (json.design !== null) {
        setLenderProfileData(JSON.parse(json.design));
      } else {
        setLenderProfileData(null);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleGetAcceptedLenderProfile = async (selectedLenderId) => {
    try {
      const response1 = await fetch(
        "https://www.smart-lend.com/api/user/getLenderProfileDesign",
        {
          method: "POST",
          body: JSON.stringify({ user_id: selectedLenderId }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        },
      );

      const json = await response1.json();
      if (json.design !== null) {
        setAcceptedLenderProfileData(JSON.parse(json.design));
      } else {
        setAcceptedLenderProfileData(null);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleRowClick = async (loanId, offerId, status) => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/loan/pendingLoan/viewOfferedLoanDetail?loan_id=${loanId}&offer_id=${offerId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        },
      );
      const json = await response.json();
      const loanDetail = json["Offered Loans Detail"][0];
      setOfferedLoanDetail(json["Offered Loans Detail"]);
      handleGetLenderProfile(loanDetail?.lender_id);
      setLenderId(loanDetail?.lender_id);
      setType(loanDetail?.type);
      setPrincipal(loanDetail?.offer_principal);
      setAmount(loanDetail?.offer_amount);
      setAdminFeeValue(loanDetail?.admin_fee);
      setInterestRateValue(loanDetail?.offer_interest_rate);
      setPeriodValue(loanDetail?.offer_period);
      setMonthlyInstallmentValue(loanDetail?.offer_monthly_installment);
      setRevenueValue(loanDetail?.offer_revenue);
      setRepaymentTenor(loanDetail?.repayment_tenor);
      setExpress(loanDetail?.express);
      setProcessingFeeValue(loanDetail?.processing_fee);
      setTotalAdminFeeValue(loanDetail?.total_admin_fee);
      setAddDocument(loanDetail?.add_document);
      setSelectedOfferId(offerId);
      setSelectedStatus(status);
      setFooterVisible(true);
    } catch (error) {
      console.error("Error retrieving Offered Loans Detail:", error);
    }
  };

  const getAuthorizationList = async (loanId) => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/loan/getAuthorization",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({ loan_id: loanId }),
        },
      );
      const json = await response.json();
      if (json.loan_authorizations.length > 0) {
        setAuthorizationModalOpen(true);
        setAuthorizationList(json.loan_authorizations);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const hideLoanRequest = async (loanId) => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/loan/hideLoanRequest",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
          body: JSON.stringify({ loan_id: loanId }),
        },
      );

      if (response.ok) {
        setRequestedLoans((prevLoans) =>
          prevLoans.map((loan) =>
            loan.loan_id === loanId ? { ...loan, make_hidden: true } : loan,
          ),
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const unhideLoanRequest = async (loanId) => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/loan/unhideLoanRequest",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
          body: JSON.stringify({ loan_id: loanId }),
        },
      );

      if (response.ok) {
        setRequestedLoans((prevLoans) =>
          prevLoans.map((loan) =>
            loan.loan_id === loanId ? { ...loan, make_hidden: false } : loan,
          ),
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const applyLoanConciergeService = async (amount, loanId) => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/loan/applyLoanConciergeService",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({
            amount: amount,
            date_request: `${formatDate(new Date())}`,
            loan_id: loanId,
          }),
        },
      );
      if (response.ok) {
        fetchRequestedLoans();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleAcceptOffer = async (loanId) => {
    const offerId = selectedOfferId;
    try {
      const item = {
        offer_id: offerId,
        loan_id: loanId,
        lender_id: lenderId,
        type: type,
        express: express,
        category: "business",
        principal: principal,
        amount: amount,
        admin_fee: adminFeeValue,
        total_admin_fee: totalAdminFeeValue,
        interest_rate: interestRateValue,
        period: periodValue,
        monthly_installment: monthlyInstallmentValue,
        revenue: revenueValue,
        processing_fee: processingFeeValue,
        repayment_tenor: repaymentTenor,
      };

      const response = await fetch(
        "https://www.smart-lend.com/api/loan/pendingLoan/acceptLoan",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify(item),
        },
      );
      const json = await response.json();

      if (response.status === 200) {
        setRequestedLoanModalStates((prevStates) => ({
          ...prevStates,
          [loanId]: false,
        }));
        message.success(json.message);
        fetchRequestedLoans();
        history.push("/b-loan-hub?tab=accepted");

        try {
          await fetch(
            "https://www.smart-lend.com/api/user/notification/sendNotification",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + Cookies.get("token"),
              },
              body: JSON.stringify({
                user_id: lenderId,
                channel: "system",
                subject: "Accept offer",
                message: "Borrower had accept your offer for loan ${}",
              }),
            },
          );
        } catch (error) {
          console.error("Error creating offer:", error);
        }

        try {
          await fetch(
            "https://www.smart-lend.com/api/profile/createActivityLog",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + Cookies.get("token"),
              },
              body: JSON.stringify({
                user_id: lenderId,
                user_name: offeredLoanDetail?.[0]?.lender_name,
                user_account_type: "lender",
                description: `${userDetails?.entity_name} has accepted your loan offer for ${loanId}`,
              }),
            },
          );
        } catch (error) {
          console.error("Error creating offer:", error);
        }
      } else if (response.status === 400) {
        setStatusMessage({
          message: "You have already accepted this loan.",
          color: "red",
        });
      }
    } catch (error) {
      console.error("Error", error);
      setStatusMessage({
        message: "Please click the table row.",
        color: "red",
      });
    }
  };

  const handleRejectOffer = async (loanId) => {
    setRejectModal(false);
    const offerId = selectedOfferId;
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/loan/pendingLoan/rejectLoan?offer_id=${offerId}&reason_id=${rejectingReason}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        },
      );
      const json = await response.json();

      try {
        await fetch(
          "https://www.smart-lend.com/api/profile/createActivityLog",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + Cookies.get("token"),
            },
            body: JSON.stringify({
              user_id: lenderId,
              user_name: offeredLoanDetail?.[0]?.lender_name,
              user_account_type: "lender",
              description: `${userDetails?.entity_name} has rejected your loan offer for ${loanId}`,
            }),
          },
        );
      } catch (error) {
        console.error("Error creating offer:", error);
      }

      if (response.status === 200) {
        setRequestedLoanModalStates((prevStates) => ({
          ...prevStates,
          [loanId]: false,
        }));
        message.success(json.message);
        fetchRequestedLoans();
      } else if (response.status === 400) {
        setStatusMessage({
          message: "You have already rejected this loan.",
          color: "red",
        });
      }
    } catch (error) {
      console.error("Error retrieving Requested Loan Details:", error);
      setStatusMessage({
        message: "Please click the table row.",
        color: "red",
      });
    }
  };

  return (
    <Box m="4px 20px 20px 20px">
      <OfferReadyModal
        open={offerAlert.open}
        product="corporate"
        onClose={closeOfferAlert}
        onViewOffer={viewOfferFromAlert}
      />
      <Modal
        open={statementCoverageModal.open}
        onCancel={closeStatementCoverageModal}
        footer={[
          <Button key="cancel" onClick={closeStatementCoverageModal}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={statementCoverageSubmitting}
            onClick={submitStatementCoverageUploads}
          >
            Submit documents
          </Button>,
        ]}
      >
        <div
          style={{
            fontSize: "16px",
            fontWeight: 700,
            color: "var(--br-text, rgba(20, 44, 68, 0.8))",
            marginBottom: "8px",
          }}
        >
          Add missing bank statements
        </div>
        <div style={{ fontSize: "12px", color: "rgba(20, 44, 68, 0.7)" }}>
          This check helps streamline your loan process. If the documents you
          already submitted are correct, you can disregard this request.
        </div>
        <div style={{ marginTop: "16px", display: "grid", gap: "12px" }}>
          {statementCoverageModal.missingMonths.length ? (
            statementCoverageModal.missingMonths.map((month) => (
              <div
                key={month.key}
                style={{
                  border: "1px solid rgba(0,0,0,0.1)",
                  borderRadius: "10px",
                  padding: "12px",
                }}
              >
                <div style={{ fontWeight: 600, fontSize: "13px" }}>
                  {month.label}
                </div>
                <input
                  type="file"
                  multiple
                  accept="application/pdf,image/*"
                  onChange={(event) =>
                    handleStatementCoverageUpload(month.key, event.target.files)
                  }
                  style={{ marginTop: "8px" }}
                />
              </div>
            ))
          ) : (
            <div style={{ fontSize: "12px", opacity: 0.7 }}>
              No missing months detected.
            </div>
          )}
        </div>
      </Modal>
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap="20px">
        <Box
          gridColumn={isMobile ? "span 12" : "span 9"}
          gridRow="span 2"
          borderRadius="10px"
          style={{
            overflowY: "hidden",
            height: "calc(100% + 10px)",
            width: "100%",
            border: "none",
          }}
        >
          <Modal
            width={isMobile ? "90vw" : "520px"}
            open={Boolean(repaymentModalLoan)}
            onCancel={() => setRepaymentModalLoan(null)}
            footer={null}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <div
                style={{
                  fontWeight: 800,
                  fontSize: "16px",
                  color: "rgba(0,0,0,0.7)",
                }}
              >
                Repayment Schedule
              </div>
              <div
                style={{
                  fontSize: "12px",
                  color: "rgba(0,0,0,0.5)",
                }}
              >
                Loan ID: {repaymentModalLoan?.loan_id || "-"}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  maxHeight: "55vh",
                  overflowY: "auto",
                  paddingRight: "4px",
                }}
              >
                {(repaymentModalLoan?.repaymentSchedule || []).length ? (
                  repaymentModalLoan.repaymentSchedule.map((repay) => {
                    const repaymentStatus = getRepaymentStatusConfig(
                      repay,
                    );
                    return (
                      <div
                        key={repay.repay_id}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: "12px",
                          padding: "12px",
                          borderRadius: "var(--br-card-radius, 10px)",
                          border: "1px solid rgba(0,0,0,0.08)",
                          background: "var(--br-surface, #fff)",
                        }}
                      >
                        <div>
                          <div
                            style={{
                              fontSize: "13px",
                              fontWeight: 700,
                              color: "rgba(0,0,0,0.75)",
                            }}
                          >
                            Due {formatDate(repay.repay_due_date)}
                          </div>
                          <div
                            style={{
                              fontSize: "12px",
                              color: "rgba(0,0,0,0.55)",
                            }}
                          >
                            {formatCurrency(repay.repay_total_amount)}
                          </div>
                        </div>
                        <div
                          style={{
                            fontSize: "11px",
                            fontWeight: 700,
                            color: repaymentStatus.color,
                            textTransform: "uppercase",
                          }}
                        >
                          {repaymentStatus.label}
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div
                    style={{
                      fontSize: "12px",
                      color: "rgba(0,0,0,0.5)",
                    }}
                  >
                    Repayment schedule has not been provided yet.
                  </div>
                )}
              </div>
            </div>
          </Modal>
          <div className="loanPageCard">
            <div
              className="loanPageHeader"
              style={{ borderBottom: "1px solid rgba(20, 44, 68, 0.08)" }}
            >
              <p className="loanTitle">Corporate Loan</p>
              <div className="loanSubtitle">
                Apply once, track offers, and manage your loan journey.
              </div>
            </div>

            <div className="loan-tabs-wrap">
              <Tabs
                className="loan-tabs"
                activeKey={activeTab}
                onChange={switchTab}
              >
                <TabPane
                  tab="Apply Loan"
                  key="apply"
                  style={{ marginTop: "-10px" }}
                >
                  <Form
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    style={{ padding: 0 }}
                  >
                    <div className="loanApplyCard">
                      <div
                        style={{
                          background:
                            "rgba(var(--br-primary-rgb, 96,169,247), 0.1)",
                          border:
                            "1px solid rgba(var(--br-primary-rgb, 67,121,178), 1)",
                          padding: "10px",
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                          borderRadius: "var(--br-card-radius, 10px)",
                          position: "relative",
                        }}
                      >
                        <div
                          style={{
                            background:
                              "rgba(var(--br-primary-rgb, 0,76,158), 1)",
                            padding: "10px",
                            borderRadius: "var(--br-card-radius, 8px)",
                            width: "50px",
                            height: "50px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <StarBorderIcon
                            style={{ color: "white", fontSize: 28 }}
                          />
                        </div>
                        <div style={{ marginLeft: "15px" }}>
                          <div
                            style={{
                              fontWeight: 700,
                              fontSize: !isMobile ? 18 : 14,
                              lineHeight: !isMobile ? "18px" : "14px",
                            }}
                          >
                            More lenders, more choices, one application
                          </div>
                          <div
                            style={{
                              marginTop: !isMobile ? "0px" : "4px",
                              fontSize: 12,
                            }}
                          >
                            Your request reaches our full network of licensed
                            P2P corporate lenders at once, so competing offers
                            come to you. Compare side by side and choose on your
                            own terms.{" "}
                            <strong>
                              - No broker fees, no middle man, no hidden
                              charges.
                            </strong>
                          </div>
                        </div>
                      </div>
                      <div
                        className="loanApplyHeaderRow"
                        style={{ marginTop: "20px" }}
                      >
                        <div>
                          <div className="loanApplyTitle">Loan Application</div>
                          <div className="loanApplyHint">
                            Submit a request and let lenders start sending
                            offers.
                          </div>
                        </div>

                        {/* Optional: keep if you want parity with Personal's right pill */}
                        <div className="loanApplyPill">Fast approval flow</div>
                      </div>

                      {!isMobile ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            gap: "20px",
                            marginTop: "15px",
                            marginBottom: "15px",
                          }}
                        >
                          <div
                            style={{
                              padding: "5px 15px",
                              borderRadius: "var(--br-card-radius, 20px)",
                              background: "rgba(96, 247, 157, 0.1)",
                              border: "1px solid rgba(67, 178, 139, 1)",
                              color: "rgba(0, 158, 87, 1)",
                            }}
                          >
                            ● Less than 3 mins to apply
                          </div>
                          <div
                            style={{
                              padding: "5px 15px",
                              borderRadius: "var(--br-card-radius, 20px)",
                              background: "rgba(114, 96, 247, 0.1)",
                              border: "1px solid rgba(67, 67, 178, 1)",
                              color: "rgba(18, 0, 158, 1)",
                            }}
                          >
                            ● Offers within 24 hours
                          </div>
                          <div
                            style={{
                              padding: "5px 15px",
                              borderRadius: "var(--br-card-radius, 20px)",
                              background: "rgba(114, 96, 247, 0.1)",
                              border: "1px solid rgba(67, 67, 178, 1)",
                              color: "rgba(18, 0, 158, 1)",
                            }}
                          >
                            ● No broker or platform fee
                          </div>
                        </div>
                      ) : null}
                      <div className="loanDivider" />

                      {/* IMPORTANT: remove the 90% widths. Let columns + gutters handle spacing */}
                      <Row gutter={[16, 10]}>
                        <Col xs={24} md={8}>
                          <Form.Item label="Loan Category">
                            <Select
                              value={loanType}
                              onChange={(v) => setLoanType(v)}
                              allowClear
                              defaultValue="simple"
                            >
                              <Option value="simple">
                                Unsecured Business Term Loan
                              </Option>
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col xs={24} md={8}>
                          <Form.Item label="Expected Processing Fee">
                            <Select
                              value={adminFee}
                              onChange={(v) => setAdminFeeSelected(v)}
                              defaultValue="0.05"
                              allowClear
                            >
                              <Option value="0.03">1-3%</Option>
                              <Option value="0.05">3.1-5%</Option>
                              <Option value="0.07">5.1-7%</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row gutter={[16, 10]}>
                        <Col xs={24} md={8}>
                          <Form.Item label="Requested Loan Amount">
                            <InputNumber
                              value={requestingLoanAmount}
                              onChange={(v) => {
                                setRequestLoanAmount(v);
                                if (!trackingRef.current.enteredLoanAmount) {
                                  sendTrackingUpdate({
                                    enteredLoanAmount: true,
                                    loanAmount: v ?? null,
                                  });
                                  return;
                                }
                                sendTrackingUpdate({ loanAmount: v ?? null });
                              }}
                              formatter={(value) =>
                                value
                                  ? `$ ${value}`.replace(
                                      /\B(?=(\d{3})+(?!\d))/g,
                                      ",",
                                    )
                                  : ""
                              }
                              parser={(value) =>
                                value.replace(/\$\s?|(,*)/g, "")
                              }
                              defaultValue={50000}
                            />
                          </Form.Item>
                        </Col>

                        <Col xs={24} md={8}>
                          <Form.Item label="Interest Rate (Month) (%)">
                            <Select
                              value={expectingInterestRate}
                              defaultValue="3"
                              onChange={(v) => {
                                setExpectingInterestRate(v);
                                if (!trackingRef.current.enteredInterestRate) {
                                  sendTrackingUpdate({
                                    enteredInterestRate: true,
                                  });
                                }
                              }}
                            >
                              <Option value="2">1.1%-2%</Option>
                              <Option value="3">2.1%-3%</Option>
                              <Option value="5">3.1%-5%</Option>
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col xs={24} md={8}>
                          <Form.Item label="Loan Period (Month)">
                            <InputNumber
                              value={loanPeriod}
                              onChange={(v) => {
                                setLoanPeriod(v);
                                if (!trackingRef.current.enteredTenor) {
                                  sendTrackingUpdate({ enteredTenor: true });
                                }
                              }}
                              formatter={(v) =>
                                parseFloat(v) === 1
                                  ? `${v} month`
                                  : `${v} months`
                              }
                              parser={(v) => v.replace(" months", "")}
                              min={1}
                              defaultValue={12}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      {showHighAmountWarning ? (
                        <div
                          style={{
                            padding: "8px 15px",
                            borderRadius: "var(--br-card-radius, 10px)",
                            border: "1px solid rgba(144, 58, 8, 1)",
                            background: "rgba(144, 58, 8,0.1)",
                            color: "rgba(144, 58, 8, 1)",
                            display: "flex",
                            alignItems: "center",
                            gap: "20px",
                          }}
                        >
                          <WarningAmberIcon style={{ fontSize: "30px" }} />
                          <span>
                            Loan amounts above S$500,000 require additional
                            vetting — our team will review your request before
                            it goes live on the marketplace. This may take
                            slightly longer than usual.
                          </span>
                        </div>
                      ) : null}
                      {showLowInterestRateWarning ? (
                        <div
                          style={{
                            padding: "8px 15px",
                            borderRadius: "var(--br-card-radius, 10px)",
                            border: "1px solid rgba(144, 58, 8, 1)",
                            background: "rgba(144, 58, 8,0.1)",
                            color: "rgba(144, 58, 8, 1)",
                            display: "flex",
                            alignItems: "center",
                            gap: "20px",
                            marginTop: "8px",
                          }}
                        >
                          <WarningAmberIcon style={{ fontSize: "30px" }} />
                          <span>
                            Fewer lenders may respond — choosing a lower rate
                            reduces your offer pool. Consider a slightly higher
                            range to maximize options.
                          </span>
                        </div>
                      ) : null}
                      {showLongTenorWarning ? (
                        <div
                          style={{
                            padding: "8px 15px",
                            borderRadius: "var(--br-card-radius, 10px)",
                            border: "1px solid rgba(144, 58, 8, 1)",
                            background: "rgba(144, 58, 8,0.1)",
                            color: "rgba(144, 58, 8, 1)",
                            display: "flex",
                            alignItems: "center",
                            gap: "20px",
                            marginTop: "8px",
                          }}
                        >
                          <WarningAmberIcon style={{ fontSize: "30px" }} />
                          <span>
                            Loan tenors above 12 months may limit your lender
                            pool — fewer P2P corporate lenders offer longer-term
                            facilities. Consider a shorter tenor for more
                            competing offers.
                          </span>
                        </div>
                      ) : null}

                      <div className="loanDivider" />

                      <div className="loanEstimates">
                        <div
                          className="loanEstimateSummary"
                          role="button"
                          tabIndex={0}
                          onClick={() =>
                            setShowEstimateBreakdown((previous) => !previous)
                          }
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              setShowEstimateBreakdown((previous) => !previous);
                            }
                          }}
                        >
                          <div>
                            <div className="loanEstimateHeadline">
                              Estimated monthly repayment
                            </div>
                            <div className="loanEstimateHeroValue">
                              {formatCurrency(monthlyInstallment)}
                              <span>/month</span>
                            </div>
                            <div className="loanEstimateHeroSub">
                              Based on{" "}
                              {Number(expectingInterestRate || 0).toFixed(2)}%
                              p.m. · {Number(loanPeriod || 0)} months ·{" "}
                              {formatCurrency(requestingLoanAmount)}
                            </div>
                          </div>

                          <div className="loanEstimateSummaryRight">
                            <div className="loanEstimateStatusPill">
                              ✓ Within allowed range
                            </div>
                            <div className="loanEstimateAllowedText">
                              Allowed preferred interest range: 2.1% - 4.0% p.m.
                            </div>
                            <div className="loanEstimateTogglePill">
                              {showEstimateBreakdown
                                ? "Hide repayment breakdown"
                                : "Show repayment breakdown"}
                            </div>
                          </div>
                        </div>

                        {showEstimateBreakdown ? (
                          <div className="loanEstimatesGrid">
                            <div className="loanEstimateLabel">
                              Total cost of Financing
                              <Tooltip
                                mouseEnterDelay={0}
                                mouseLeaveDelay={0}
                                placement="topRight"
                                title={`Total Financing Cost = Loan Amount + Processing Fee + Total Interest`}
                              >
                                <button type="button" className="loanInfoBtn">
                                  <QuestionOutlined style={{ fontSize: 9 }} />
                                </button>
                              </Tooltip>
                            </div>
                            <div className="loanEstimateValue">
                              {formatCurrency(
                                requestPrincipal +
                                  Number(requestingLoanAmount || 0) *
                                    Number(adminFee || 0),
                              )}
                            </div>

                            <div className="loanEstimateDivider" />

                            <div className="loanEstimateLabel">
                              Expected Disbursed Amount
                              <Tooltip
                                mouseEnterDelay={0}
                                mouseLeaveDelay={0}
                                placement="topRight"
                                title={`Amount you'll receive: Requested Loan Amount - Processing Fee`}
                              >
                                <button type="button" className="loanInfoBtn">
                                  <QuestionOutlined style={{ fontSize: 9 }} />
                                </button>
                              </Tooltip>
                            </div>
                            <div className="loanEstimateValue">
                              {formatCurrency(
                                Number(requestingLoanAmount || 0) *
                                  (1 - Number(adminFee || 0)),
                              )}
                            </div>

                            <div className="loanEstimateDivider" />

                            <div className="loanEstimateLabel">
                              Expected Processing Fee
                              <Tooltip
                                mouseEnterDelay={0}
                                mouseLeaveDelay={0}
                                placement="topRight"
                                title={`Max processing fee incurred on the loan.`}
                              >
                                <button type="button" className="loanInfoBtn">
                                  <QuestionOutlined style={{ fontSize: 9 }} />
                                </button>
                              </Tooltip>
                            </div>
                            <div className="loanEstimateValue">
                              {formatCurrency(
                                Number(requestingLoanAmount || 0) *
                                  Number(adminFee || 0),
                              )}
                            </div>

                            <div className="loanEstimateDivider" />

                            <div className="loanEstimateLabel">
                              Expected Monthly Instalment
                              <Tooltip
                                mouseEnterDelay={0}
                                mouseLeaveDelay={0}
                                placement="topRight"
                                title={`Estimated monthly payment.`}
                              >
                                <button type="button" className="loanInfoBtn">
                                  <QuestionOutlined style={{ fontSize: 9 }} />
                                </button>
                              </Tooltip>
                            </div>
                            <div className="loanEstimateValue">
                              {formatCurrency(monthlyInstallment)}
                            </div>

                            <div className="loanEstimateDivider" />

                            <div className="loanEstimateLabel">
                              Total Interest Payable
                              <Tooltip
                                mouseEnterDelay={0}
                                mouseLeaveDelay={0}
                                placement="topRight"
                                title={`Calculated using the upper limit of your selected interest rate range.`}
                              >
                                <button type="button" className="loanInfoBtn">
                                  <QuestionOutlined style={{ fontSize: 9 }} />
                                </button>
                              </Tooltip>
                            </div>
                            <div className="loanEstimateValue">
                              {formatCurrency(totalInterestPayable)}
                            </div>
                          </div>
                        ) : null}
                      </div>

                      {/* Buttons stay the same; the CSS will make them match */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          gap: 12,
                          flexWrap: "wrap",
                          marginTop: "15px",
                        }}
                      >
                        {/* ... your Sync button ... */}
                        <Button
                          type="primary"
                          htmlType="submit"
                          onClick={showModal}
                          disabled={isApplyDisabled}
                        >
                          Send Application
                        </Button>
                        {reminder ? (
                          <Button
                            type="primary"
                            htmlType="submit"
                            onClick={() => {
                              history.push("/stg-b-profile");
                            }}
                            style={{
                              maxWidth: isMobile ? "100%" : 240,
                              width: isMobile ? "100%" : "auto",
                              background: `transparent`,
                              color: "var(--br-primary, rgb(14, 90, 165))",
                            }}
                          >
                            Retrieve Corppass Data
                          </Button>
                        ) : null}
                      </div>
                      {reminder ? (
                        <Typography
                          color="#b22"
                          fontSize="12px"
                          marginTop="10px"
                          textAlign="center"
                          fontWeight={800}
                        >
                          Your corppass data is outdated. Please resync to
                          proceed.
                        </Typography>
                      ) : null}
                      {existingLoanData ? (
                        <Typography
                          color="#b22"
                          fontSize="12px"
                          marginTop="10px"
                          textAlign="center"
                          fontWeight={800}
                        >
                          You have applied for a loan within the last 30 days.
                          Please wait before submitting a new application.
                        </Typography>
                      ) : null}
                      <FaqSection />
                      {isModalOpen ? (
                        <ModalApplication
                          loanType={loanType}
                          loanCategory={loanCategory}
                          requestingLoanAmount={requestingLoanAmount}
                          expectingInterestRate={expectingInterestRate}
                          loanPeriod={loanPeriod}
                          request_principal={requestPrincipal}
                          request_monthly_installment={monthlyInstallment}
                          total_admin_fee_by_month={totalAdminFeeByMonth}
                          total_admin_fee={totalAdminFee}
                          request_revenue={totalInterestPayable}
                          adminFee={adminFee}
                          promoCode={promoCode}
                          keymanChoices={keymanChoices}
                          onClose={handleCancel}
                        />
                      ) : null}
                    </div>
                  </Form>
                </TabPane>
                <TabPane tab="Requested Loans" key="requested">
                  <div className="loanCardsWrap">
                    {requestedLoans && requestedLoans.length > 0 ? (
                      requestedLoans.map((item) => {
                        const loanStatus = item.make_hidden
                          ? "Withdrawn from Market"
                          : item.status === "accepted"
                            ? "Pending Acceptance"
                            : item.status
                              ? item.status.charAt(0).toUpperCase() +
                                item.status.slice(1)
                              : "-";
                        const isWithdrawn = item.make_hidden;
                        const interestRateLabel =
                          item.request_interest_rate === 2
                            ? "1.1% - 2%"
                            : item.request_interest_rate === 3
                              ? "2.1% - 3%"
                              : "3.1% - 5%";
                        const caseViewCount = item.viewed_by
                          ? `${JSON.parse(item.viewed_by).length} views`
                          : "No views";

                        return (
                          <div
                            key={item.loan_id}
                            className={[
                              "slCard",
                              isMobile ? "isMobile" : "",
                              isWithdrawn ? "withdrawn" : "",
                            ].join(" ")}
                          >
                            <div className="slTopRow">
                              <div className="slPills">
                                {isWithdrawn ? (
                                  <span className="slPill warning">
                                    Withdrawn
                                  </span>
                                ) : (
                                  <span
                                    className={[
                                      "slPill",
                                      loanStatus === "Pending Acceptance"
                                        ? "info"
                                        : loanStatus === "Offered"
                                          ? "info"
                                          : loanStatus === "Pending"
                                            ? "warning"
                                            : loanStatus === "Accepted"
                                              ? "success"
                                              : "info",
                                    ].join(" ")}
                                  >
                                    {loanStatus}
                                  </span>
                                )}

                                <span className="slPill">{caseViewCount}</span>
                              </div>

                              {/* optional “menu” button placeholder (future: hide/unhide/other actions) */}
                              <button
                                type="button"
                                className="slKebab"
                                onClick={(e) => {
                                  e.preventDefault();
                                  // if you want: toggle a dropdown later
                                }}
                                aria-label="More actions"
                                title="More"
                              >
                                ⋯
                              </button>
                            </div>

                            <div className="slHeader">
                              <div className="slAmountLabel">Loan amount</div>
                              <div className="slAmountValue">
                                {item.request_amount
                                  ? item.request_amount.toLocaleString(
                                      "en-US",
                                      {
                                        style: "currency",
                                        currency: "SGD",
                                      },
                                    )
                                  : "-"}
                              </div>
                              <div className="slSubLine">
                                Created {formatDate(item.created_at)} •{" "}
                                {interestRateLabel} / month
                              </div>
                            </div>

                            <div className="slMetaGrid">
                              <div className="slMetaItem">
                                <div className="slMetaK">Monthly</div>
                                <div className="slMetaV">
                                  {item.request_monthly_installment
                                    ? item.request_monthly_installment.toLocaleString(
                                        "en-US",
                                        {
                                          style: "currency",
                                          currency: "SGD",
                                        },
                                      )
                                    : "-"}
                                </div>
                              </div>

                              <div className="slMetaItem">
                                <div className="slMetaK">Period</div>
                                <div className="slMetaV">
                                  {item.request_period
                                    ? `${item.request_period} months`
                                    : "-"}
                                </div>
                              </div>

                              <div className="slMetaItem">
                                <div className="slMetaK">Status</div>
                                <div className="slMetaV">{loanStatus}</div>
                              </div>

                              <div className="slMetaItem">
                                <div className="slMetaK">Expires</div>
                                <div className="slMetaV">
                                  {item.expired_date
                                    ? formatDate(item.expired_date)
                                    : "-"}
                                </div>
                              </div>
                            </div>

                            {/* Keep your statement coverage block but wrap it as a nicer note */}
                            {statementCoverageEnabled ? (
                              <div
                                className="slMutedNote"
                                style={{ marginTop: 2 }}
                              >
                                <div
                                  style={{ fontWeight: 850, marginBottom: 6 }}
                                >
                                  Bank statement coverage (last 6 months)
                                </div>

                                {statementCoverageLoading[item.loan_id] ? (
                                  <div>Checking coverage...</div>
                                ) : statementCoverageMap[item.loan_id]
                                    ?.is_complete ? (
                                  <div>All required months are present.</div>
                                ) : statementCoverageMap[item.loan_id]
                                    ?.missing_months?.length ? (
                                  <>
                                    <div>
                                      Missing:{" "}
                                      {statementCoverageMap[
                                        item.loan_id
                                      ].missing_months
                                        .map((month) => month.label)
                                        .join(", ")}
                                    </div>
                                    <div style={{ marginTop: 6, opacity: 0.8 }}>
                                      If your documents are correct, you can
                                      disregard this notice.
                                    </div>
                                    <Button
                                      className="slBtn slBtnOutline"
                                      style={{ marginTop: 10 }}
                                      onClick={() =>
                                        openStatementCoverageModal(
                                          item,
                                          statementCoverageMap[item.loan_id]
                                            .missing_months,
                                        )
                                      }
                                    >
                                      Add missing documents
                                    </Button>
                                  </>
                                ) : (
                                  <div>No statement data available yet.</div>
                                )}
                              </div>
                            ) : null}

                            <div className="slDividerLine" />

                            <div className="slActions">
                              {item.authorization_completed === false &&
                              item.authorization_required === 1 ? (
                                <button
                                  className="slBtn slBtnPrimary"
                                  style={{
                                    background:
                                      "linear-gradient(90deg, #ef4444 0%, #fb7185 100%)",
                                  }}
                                  onClick={(event) => {
                                    event.preventDefault();
                                    getAuthorizationList(item.loan_id);
                                  }}
                                >
                                  Requires Authorisation
                                </button>
                              ) : null}

                              {!isWithdrawn &&
                              [
                                "Offered",
                                "Pending Acceptance",
                                "Pending",
                              ].includes(loanStatus) ? (
                                <button
                                  className="slBtn slBtnOutline"
                                  onClick={(event) => {
                                    event.preventDefault();
                                    handleViewOfferedLoan(item.loan_id);
                                  }}
                                >
                                  View offers
                                </button>
                              ) : null}

                              {/* Withdraw / Push */}
                              {new Date(item.expired_date) > new Date() &&
                              !item.make_hidden ? (
                                <button
                                  className="slBtn slBtnPrimary"
                                  onClick={() => hideLoanRequest(item.loan_id)}
                                >
                                  Withdraw from market
                                </button>
                              ) : (
                                <button
                                  className="slBtn slBtnPrimary"
                                  onClick={() =>
                                    unhideLoanRequest(item.loan_id)
                                  }
                                >
                                  Push to market
                                </button>
                              )}

                              {!isWithdrawn && !item.applied_for_concierge ? (
                                <button
                                  className="slBtn slBtnPrimary"
                                  onClick={(event) => {
                                    event.preventDefault();
                                    setConciergeAmount(item.request_amount);
                                    setConciergeId(item.loan_id);
                                    setConciergeModalOpen(true);
                                  }}
                                >
                                  Upgrade to concierge ✨
                                </button>
                              ) : null}
                            </div>

                            <Modal
                              width={isMobile ? "100%" : "50vw"}
                              style={{
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                position: "relative",
                              }}
                              open={requestedLoanModalStates[item.loan_id]}
                              onCancel={() =>
                                handleCloseRequestedModal(item.loan_id)
                              }
                              footer={
                                footerVisible &&
                                new Date(item.expired_date) > new Date()
                                  ? [
                                      <React.Fragment key="footer-elements">
                                        {selectedStatus === "pending" && (
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "center",
                                              marginTop: "25px",
                                            }}
                                          >
                                            <Button
                                              type="primary"
                                              style={{
                                                background: "#0DC45C",
                                                borderRadius:
                                                  "var(--br-card-radius, 20px)",
                                              }}
                                              onClick={() => {
                                                setAcceptingLoanOfferLoanId(
                                                  item.loan_id,
                                                );
                                                setHideLoanModal(true);
                                              }}
                                            >
                                              Accept Offer
                                            </Button>
                                            <Button
                                              type="primary"
                                              style={{
                                                borderRadius: "20px",
                                              }}
                                              danger
                                              onClick={() => {
                                                setRejectModal(true);
                                                setRejectingOffer(item.loan_id);
                                              }}
                                            >
                                              Reject Offer
                                            </Button>
                                            <Button
                                              type="primary"
                                              style={{
                                                background:
                                                  "var(--br-surface, white)",
                                                border: "1px solid red",
                                                color: "red",
                                                borderRadius:
                                                  "var(--br-card-radius, 20px)",
                                              }}
                                              onClick={(event) => {
                                                event.preventDefault();
                                                const loanDetailIndex =
                                                  offeredLoanDetail.findIndex(
                                                    (loan) =>
                                                      loan.loan_id ===
                                                      item.loan_id,
                                                  );
                                                if (loanDetailIndex !== -1) {
                                                  const url = `/b-messages?principelname=${offeredLoanDetail[loanDetailIndex].lender_name}&userid=${offeredLoanDetail[loanDetailIndex].lender_id}&offeramount=${offeredLoanDetail[loanDetailIndex].offer_amount}`;
                                                  history.push(url);
                                                }
                                              }}
                                            >
                                              Negotiate Offer
                                            </Button>
                                          </div>
                                        )}
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            marginTop: "10px",
                                            color: statusMessage.color,
                                          }}
                                        >
                                          <p>{statusMessage.message}</p>
                                        </div>
                                      </React.Fragment>,
                                    ]
                                  : null
                              }
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  background: "var(--br-surface, white)",
                                  borderRadius: "var(--br-card-radius, 10px)",
                                  padding: "20px",
                                  top: 0,
                                  right: lenderProfileData
                                    ? "calc(100% + 20px)"
                                    : "100%",
                                  opacity: lenderProfileData ? 1 : 0,
                                  width: "400px",
                                  boxShadow:
                                    "var(--br-shadow, 0px 0px 10px rgba(0,0,0,0.05))",
                                  transition: "0.4s all ease-in-out",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    gap: "15px",
                                  }}
                                >
                                  <div>
                                    <img
                                      style={{
                                        height: "80px",
                                        width: "80px",
                                        borderRadius: "50%",
                                        background: "lightgrey",
                                        boxShadow:
                                          "var(--br-shadow, 0px 0px 10px rgba(0,0,0,0.05))",
                                        objectFit: "cover",
                                      }}
                                      src={
                                        lenderProfileData?.profile
                                          ?.profile_photo
                                      }
                                    />
                                  </div>
                                  <div style={{ width: "100%" }}>
                                    <div
                                      style={{
                                        color:
                                          "var(--br-primary, rgb(14, 90, 165))",
                                        fontSize: "20px",
                                        fontFamily: "Manrope,sans-serif",
                                        fontWeight: 800,
                                        marginBottom: "5px",
                                      }}
                                    >
                                      {lenderProfileData?.profile?.company_name}
                                    </div>
                                    {lenderProfileData?.profile?.additionals?.map(
                                      (addi, index) => (
                                        <div
                                          key={index}
                                          style={{
                                            display: "flex",
                                            gap: "10px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              width: "100%",
                                              border: "none",
                                              outline: "none",
                                              color: "rgba(0,0,0,0.6)",
                                              marginTop: "-5px",
                                              fontSize: "12px",
                                              fontWeight: "400",
                                            }}
                                          >
                                            {addi?.text}
                                          </div>
                                        </div>
                                      ),
                                    )}
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        flexWrap: "wrap",
                                        marginLeft: "-5px",
                                        marginTop: "5px",
                                      }}
                                    >
                                      {lenderProfileData?.profile?.social?.map(
                                        (soci, index) => (
                                          <div
                                            key={index}
                                            style={{
                                              padding: "5px",
                                              position: "relative",
                                            }}
                                          >
                                            <FontAwesomeIcon
                                              icon={iconLibrary[soci?.icon]}
                                              style={{
                                                fontSize: 20,
                                                color:
                                                  "var(--br-primary, rgb(14, 90, 165))",
                                                cursor: "pointer",
                                              }}
                                              onClick={() => {
                                                if (
                                                  soci.link !== "" &&
                                                  soci.link !== null
                                                ) {
                                                  window.location.href =
                                                    soci.link;
                                                }
                                              }}
                                            />
                                          </div>
                                        ),
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <hr
                                  style={{
                                    width: "90%",
                                    marginLeft: "5%",
                                    background: "grey",
                                    border: "none",
                                    outline: "none",
                                  }}
                                />
                                {lenderProfileData?.content?.map(
                                  (cont, index) =>
                                    cont.type === "text" ? (
                                      <div
                                        key={index}
                                        style={{
                                          position: "relative",
                                          marginTop: cont.mt,
                                          marginBottom: cont.mb,
                                          textDecoration: cont.underline
                                            ? "underline"
                                            : "none",
                                          fontWeight:
                                            cont.fontWeight === 400 ? 400 : 600,
                                          fontSize:
                                            cont.fontWeight === 400
                                              ? "12px"
                                              : "16px",
                                          border: "none",
                                          outline: "none",
                                          color: "rgba(0,0,0,0.6)",
                                          width: "100%",
                                        }}
                                      >
                                        {cont?.text}
                                      </div>
                                    ) : cont?.type === "button" ? (
                                      <div
                                        key={index}
                                        style={{
                                          position: "relative",
                                          display: "flex",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          if (
                                            cont.url !== "" &&
                                            cont.url !== null
                                          ) {
                                            window.location.href = cont.url;
                                          }
                                        }}
                                      >
                                        <div
                                          style={{
                                            marginTop: cont.mt,
                                            marginBottom: cont.mb,
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            border:
                                              "1px solid rgba(0,0,0,0.05)",
                                            outline: "none",
                                            color: "white",
                                            background:
                                              "var(--br-primary, rgb(14, 90, 165))",
                                            padding: "7px 30px",
                                            borderRadius:
                                              "var(--br-card-radius, 30px)",
                                          }}
                                        >
                                          {cont?.text}
                                        </div>
                                      </div>
                                    ) : (
                                      <div
                                        key={index}
                                        style={{
                                          position: "relative",
                                          marginTop: cont.mt,
                                          marginBottom: cont.mb,
                                        }}
                                      >
                                        <img
                                          style={{
                                            objectFit: "cover",
                                            width: "80%",
                                            height: "150px",
                                            border: "none",
                                            outline: "none",
                                          }}
                                          src={cont?.url}
                                        />
                                      </div>
                                    ),
                                )}
                              </div>
                              <Typography
                                color={colors.grey[920]}
                                variant="h5"
                                fontWeight="800"
                                fontFamily="Manrope, sans-serif"
                                fontSize="18px"
                                style={{ marginBottom: "15px" }}
                              >
                                Offered Loan
                              </Typography>
                              <div style={{ width: "100%", overflowX: "auto" }}>
                                <TableOfferedLoan
                                  loan_id={item.loan_id}
                                  add_document={addDocument}
                                  onRowClick={(loanId, offerId, status) =>
                                    handleRowClick(loanId, offerId, status)
                                  }
                                />
                              </div>
                              <div style={{ marginTop: "15px" }}>
                                {offeredLoanDetail &&
                                offeredLoanDetail.length > 0 ? (
                                  <LoanDetails
                                    offeredLoanDetail={offeredLoanDetail}
                                  />
                                ) : (
                                  <Typography
                                    color={colors.grey[920]}
                                    fontFamily="Manrope, sans-serif"
                                    fontSize="14px"
                                  >
                                    Please click on the table row to display the
                                    loan details.
                                  </Typography>
                                )}
                              </div>
                            </Modal>
                          </div>
                        );
                      })
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          padding: "0px 0px",
                          marginTop: "15px",
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            padding: "0px 15px",
                            background:
                              "var(--br-surface, rgba(255,255,255,0.7))",
                            borderRadius: "var(--br-card-radius, 10px)",
                            height: "150px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontFamily: "Manrope, sans-serif",
                            fontSize: "0.8em",
                            fontWeight: "600",
                            color: "#00000066",
                          }}
                        >
                          You have no loan request
                        </div>
                      </div>
                    )}
                  </div>

                  <Modal
                    open={authorizationModalOpen}
                    onCancel={() => setAuthorizationModalOpen(false)}
                    footer={null}
                    style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
                  >
                    <div
                      style={{
                        color: "var(--br-text, #142C44CC)",
                        fontSize: 20,
                        fontWeight: 800,
                      }}
                    >
                      Authorisation | One more step
                    </div>
                    <div
                      style={{
                        color: "rgba(0, 0, 0, 0.6)",
                        fontSize: 12,
                        fontWeight: 500,
                        marginBottom: 7,
                      }}
                    >
                      For your loan to appear on our lenders screen, you'll need
                      to provide authorisation from your shareholders.
                    </div>
                    {authorizationList.map((autho) => (
                      <div
                        key={autho.id}
                        style={{
                          width: "100%",
                          padding: "15px",
                          borderRadius: "var(--br-card-radius, 10px)",
                          boxShadow:
                            "var(--br-shadow, 0px 0px 10px rgba(0,0,0,0.2))",
                          marginTop: "10px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: 30,
                        }}
                      >
                        <div
                          style={{
                            color: "var(--br-text, #142C44CC)",
                            fontSize: 14,
                            fontWeight: 800,
                          }}
                        >
                          <div>{autho.director_name}</div>
                          <div
                            style={{
                              color: "rgba(0, 0, 0, 0.4)",
                              fontSize: 12,
                              fontWeight: 500,
                              marginBottom: 7,
                            }}
                          >
                            {autho.company_name}
                          </div>
                          <div
                            style={{
                              color: "rgba(0, 0, 0, 0.4)",
                              fontSize: 12,
                              fontWeight: 500,
                              marginBottom: 7,
                            }}
                          >
                            {autho.authorized ? "Authorised" : "Pending"}
                          </div>
                        </div>
                        <div style={{ display: "flex", gap: "10px" }}>
                          <div
                            onClick={() => {
                              const link =
                                "https://smart-lend.com/director-authorization?authorisationid=" +
                                autho.id +
                                "&company_name=" +
                                autho.company_name +
                                "&director_name=" +
                                autho.director_name;
                              window.open(link, "_blank");
                            }}
                            style={{
                              padding: "6px 12px",
                              borderRadius: "var(--br-card-radius, 20px)",
                              background: "var(--br-primary, #115CA6)",
                              color: "white",
                              fontSize: 12,
                              cursor: "pointer",
                            }}
                          >
                            Open link
                          </div>
                          <div
                            onClick={async () => {
                              const link =
                                "https://smart-lend.com/director-authorization?authorisationid=" +
                                autho.id +
                                "&company_name=" +
                                autho.company_name +
                                "&director_name=" +
                                autho.director_name;
                              try {
                                await navigator.clipboard.writeText(link);
                                message.success("Authorization link copied.");
                              } catch (error) {
                                message.error("Unable to copy link.");
                              }
                            }}
                            style={{
                              padding: "6px 12px",
                              borderRadius: 20,
                              border: "1px solid var(--br-primary, #115CA6)",
                              color: "var(--br-primary, #115CA6)",
                              fontSize: 12,
                              cursor: "pointer",
                            }}
                          >
                            Copy link
                          </div>
                        </div>
                      </div>
                    ))}
                  </Modal>

                  <Modal
                    open={conciergeModalOpen}
                    onCancel={() => setConciergeModalOpen(false)}
                    footer={null}
                  >
                    <div
                      style={{
                        color: "var(--br-text, #142C44CC)",
                        fontSize: 18,
                        fontWeight: 800,
                      }}
                    >
                      Upgrade to Concierge
                    </div>
                    <div
                      style={{
                        color: "rgba(0, 0, 0, 0.6)",
                        fontSize: 12,
                        fontWeight: 500,
                        marginBottom: 15,
                        marginTop: 6,
                      }}
                    >
                      Our concierge team will help fast-track your loan request.
                      Ready to proceed?
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px",
                      }}
                    >
                      <Button
                        type="primary"
                        style={{
                          borderRadius: "20px",
                          padding: "6px 20px",
                        }}
                        onClick={() => {
                          applyLoanConciergeService(
                            conciergeAmount,
                            conciergeId,
                          );
                          setConciergeModalOpen(false);
                        }}
                      >
                        Apply Now
                      </Button>
                      <Button
                        style={{
                          borderRadius: "20px",
                          padding: "6px 20px",
                        }}
                        onClick={() => setConciergeModalOpen(false)}
                      >
                        Cancel
                      </Button>
                    </div>
                  </Modal>

                  <Modal
                    style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
                    open={rejectModal}
                    onCancel={() => {
                      setRejectModal(false);
                      setRejectingOffer(null);
                      setRejectingReason(0);
                    }}
                    footer={null}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                        padding: "20px 0px 10px 0px",
                      }}
                    >
                      <div>
                        Please provide a reason why you'd like to reject this
                        offer
                      </div>
                      <div style={{ marginTop: "10px", textAlign: "center" }}>
                        <select
                          value={rejectingReason}
                          onChange={(event) =>
                            setRejectingReason(event.target.value)
                          }
                          style={{ textAlign: "center" }}
                        >
                          <option value={0}>
                            I have a better rate from another lender
                          </option>
                          <option value={1}>
                            The offer doesnt meet my requirements
                          </option>
                          <option value={2}>The rates are too high</option>
                          <option value={3}>I no longer need a loan</option>
                        </select>
                      </div>
                      {rejectingReason !== null && rejectingOffer ? (
                        <div style={{ marginTop: "20px" }}>
                          <Button
                            type="primary"
                            style={{
                              borderRadius: "20px",
                              padding: "0px 20px",
                            }}
                            danger
                            onClick={() => {
                              handleRejectOffer(rejectingOffer);
                            }}
                          >
                            Reject Offer
                          </Button>
                        </div>
                      ) : null}
                    </div>
                  </Modal>

                  <Modal
                    width={isMobile ? "100%" : "40vw"}
                    style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
                    open={hideLoanModal}
                    onCancel={() => {
                      setHideLoanModal(false);
                      setAcceptingLoanOfferLoanId(null);
                    }}
                    footer={
                      <div style={{ display: "flex", gap: "10px" }}>
                        <button
                          type="primary"
                          style={{
                            background: "var(--br-primary, rgb(10, 88, 202))",
                            borderRadius: "var(--br-card-radius, 20px)",
                            padding: "7px 30px",
                            border: "none",
                            color: "white",
                          }}
                          onClick={(event) => {
                            event.preventDefault();
                            hideLoanRequest(acceptingOfferLoanId);
                            handleAcceptOffer(acceptingOfferLoanId);
                            setHideLoanModal(false);
                          }}
                        >
                          <div style={{ margin: 0 }}>Yes</div>
                        </button>
                        <button
                          type="primary"
                          style={{
                            color: "var(--br-primary, rgb(10, 88, 202))",
                            border:
                              "2px solid var(--br-primary, rgb(10, 88, 202))",
                            borderRadius: "20px",
                            padding: "7px 30px",
                            color: "white",
                          }}
                          onClick={(event) => {
                            event.preventDefault();
                            handleAcceptOffer(acceptingOfferLoanId);
                            setHideLoanModal(false);
                          }}
                        >
                          <div
                            style={{
                              margin: 0,
                              color: "var(--br-primary, rgb(10, 88, 202))",
                            }}
                          >
                            No
                          </div>
                        </button>
                      </div>
                    }
                  >
                    <Typography
                      color={colors.grey[920]}
                      variant="h5"
                      fontWeight="800"
                      fontFamily="Manrope, sans-serif"
                      fontSize="18px"
                      style={{ marginBottom: "15px" }}
                    >
                      Withdraw Loan Request
                    </Typography>
                    <div
                      style={{
                        color: "var(--br-text, #142C44CC)",
                        fontSize: 14,
                        fontWeight: 500,
                        width: "90%",
                        marginTop: "-10px",
                      }}
                    >
                      We are happy that you have found an offer to your liking,
                      would you like to withdraw your loan request as you accept
                      this offer?
                    </div>
                  </Modal>
                </TabPane>
                <TabPane tab="Accepted Loans" key="accepted">
                  <Modal
                    width={isMobile ? "80vw" : "400px"}
                    style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
                    open={acceptedLenderProfileData ? true : false}
                    onCancel={() => {
                      setAcceptedLenderProfileData(null);
                    }}
                    footer={null}
                  >
                    <div style={{}}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "15px",
                        }}
                      >
                        <div>
                          <img
                            style={{
                              height: "80px",
                              width: "80px",
                              borderRadius: "50%",
                              background: "lightgrey",
                              boxShadow:
                                "var(--br-shadow, 0px 0px 10px rgba(0,0,0,0.05))",
                              objectFit: "cover",
                            }}
                            src={
                              acceptedLenderProfileData?.profile?.profile_photo
                            }
                          />
                        </div>
                        <div style={{ width: "100%" }}>
                          <div
                            style={{
                              color: "var(--br-primary, rgb(14, 90, 165))",
                              fontSize: "20px",
                              fontFamily: "Manrope,sans-serif",
                              fontWeight: 800,
                              marginBottom: "5px",
                            }}
                          >
                            {acceptedLenderProfileData?.profile?.company_name}
                          </div>
                          {acceptedLenderProfileData?.profile?.additionals?.map(
                            (addi, index) => (
                              <div
                                key={index}
                                style={{ display: "flex", gap: "10px" }}
                              >
                                <div
                                  style={{
                                    width: "100%",
                                    border: "none",
                                    outline: "none",
                                    color: "rgba(0,0,0,0.6)",
                                    marginTop: "-5px",
                                    fontSize: "12px",
                                    fontWeight: "400",
                                  }}
                                >
                                  {addi?.text}
                                </div>
                              </div>
                            ),
                          )}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexWrap: "wrap",
                              marginLeft: "-5px",
                              marginTop: "5px",
                            }}
                          >
                            {acceptedLenderProfileData?.profile?.social?.map(
                              (soci, index) => (
                                <div
                                  key={index}
                                  style={{
                                    padding: "5px",
                                    position: "relative",
                                    cursor: "pointer",
                                  }}
                                >
                                  <FontAwesomeIcon
                                    icon={iconLibrary[soci?.icon]}
                                    style={{
                                      fontSize: 20,
                                      color:
                                        "var(--br-primary, rgb(14, 90, 165))",
                                    }}
                                    onClick={() => {
                                      if (
                                        soci.link !== "" &&
                                        soci.link !== null
                                      ) {
                                        window.location.href = soci.link;
                                      }
                                    }}
                                  />
                                </div>
                              ),
                            )}
                          </div>
                        </div>
                      </div>
                      <hr
                        style={{
                          width: "90%",
                          marginLeft: "5%",
                          background: "grey",
                          border: "none",
                          outline: "none",
                        }}
                      />
                      {acceptedLenderProfileData?.content?.map((cont, index) =>
                        cont.type === "text" ? (
                          <div
                            key={index}
                            style={{
                              position: "relative",
                              marginTop: cont.mt,
                              marginBottom: cont.mb,
                              textDecoration: cont.underline
                                ? "underline"
                                : "none",
                              fontWeight: cont.fontWeight === 400 ? 400 : 600,
                              fontSize:
                                cont.fontWeight === 400 ? "12px" : "16px",
                              border: "none",
                              outline: "none",
                              color: "rgba(0,0,0,0.6)",
                              width: "100%",
                            }}
                          >
                            {cont?.text}
                          </div>
                        ) : cont?.type === "button" ? (
                          <div
                            key={index}
                            style={{
                              position: "relative",
                              display: "flex",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              if (cont.url !== "" && cont.url !== null) {
                                window.location.href = cont.url;
                              }
                            }}
                          >
                            <div
                              style={{
                                marginTop: cont.mt,
                                marginBottom: cont.mb,
                                fontWeight: 500,
                                fontSize: "14px",
                                border: "1px solid rgba(0,0,0,0.05)",
                                outline: "none",
                                color: "white",
                                background:
                                  "var(--br-primary, rgb(14, 90, 165))",
                                padding: "7px 30px",
                                borderRadius: "var(--br-card-radius, 30px)",
                              }}
                            >
                              {cont?.text}
                            </div>
                          </div>
                        ) : (
                          <div
                            key={index}
                            style={{
                              position: "relative",
                              marginTop: cont.mt,
                              marginBottom: cont.mb,
                            }}
                          >
                            <img
                              style={{
                                objectFit: "cover",
                                width: "80%",
                                height: "150px",
                                border: "none",
                                outline: "none",
                              }}
                              src={cont?.url}
                            />
                          </div>
                        ),
                      )}
                    </div>
                  </Modal>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "15px",
                      }}
                    >
                      {pendingSigndownLoans.length > 0 ? (
                        pendingSigndownLoans.map((item) =>
                          renderAcceptedLoanCard(item),
                        )
                      ) : (
                        <div style={{ color: "rgba(0,0,0,0.5)" }}>
                          You have no loans pending lender signdown.
                        </div>
                      )}
                    </div>
                  </div>
                </TabPane>
                <TabPane tab="Ongoing Loans" key="ongoing">
                  <div>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "15px",
                      }}
                    >
                      {ongoingLoans.length > 0 ? (
                        ongoingLoans.map((item) => renderAcceptedLoanCard(item))
                      ) : (
                        <div style={{ color: "rgba(0,0,0,0.5)" }}>
                          No ongoing loans yet.
                        </div>
                      )}
                    </div>
                  </div>
                </TabPane>
              </Tabs>
            </div>
          </div>
        </Box>
        {!isMobile ? (
          <Box
            gridColumn="span 3"
            gridRow="span 2"
            backgroundColor="rgba(153, 178, 205, 0)"
            overflow="auto"
            minHeight="90.5vh"
          >
            <Box
              style={{
                border: "1px solid rgba(0, 0, 0, 0.05)",
                borderRadius: "10px",
                boxShadow: "var(--br-shadow, 0px 0px 10px rgba(0,0,0,0.05))",
              }}
              gridColumn="span 2"
              opacity="1.00"
              display="flex"
              alignItems="center"
              justifyContent="center"
              position="relative"
            >
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  paddingTop: "100%",
                  borderRadius: "10px",
                  overflow: "hidden",
                }}
              >
                {adImage ? (
                  <img
                    src={adImage}
                    alt="Advertisement"
                    onClick={(event) => {
                      event.preventDefault();
                      if (adLink) {
                        let url = adLink;

                        if (!/^https?:\/\//i.test(adLink)) {
                          url = `https://${adLink}`;
                        }

                        window.open(url, "_blank");
                      }
                    }}
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "10px",
                      cursor: adLink ? "pointer" : "default",
                    }}
                  />
                ) : null}
              </div>
            </Box>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

export default LoanHub;
